<mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()" (click)="$event.stopPropagation()"
    (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>